// There is a global Amplitude variable made available from app/assets/javascripts/application.js
// requiring the file app/assets/javascripts/third_party/amplitude.jsx
// Since we don't want to reference a global everywhere, lets do it once in here.
// Ideally, we'll be able to put all the Amplitude initialization in here one day.

// eslint-disable-next-line no-undef
export const useTracker = () => window.Amplitude
